export enum ListingStatus {
  SAVE = 0,
  SUBMIT = 1,
  SUCCESS = 2,
  FAIL = 3,
  EXPIRED = 4
}

export const ListingStatusTextMap: Record<ListingStatus, string> = {
  [ListingStatus.SAVE]: '待挂牌',
  [ListingStatus.SUBMIT]: '待审核',
  [ListingStatus.SUCCESS]: '挂牌中',
  [ListingStatus.FAIL]: '未通过',
  [ListingStatus.EXPIRED]: '已过期'
}
